import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import Datagrid from '../../../UI/Datagrid';
import DeleteRecord from '../../../UI/DeleteRecord';
import { Alert, NavButton } from '../../../UI/Common';
import ReactSelect from '../../../UI/ReactSelect';

const AlarmIndicatorsPage = (props) => {
  //prettier-ignore
  const { t, errors, departments, alarmIndicators, isFetching, datagridProps, openModal } = props;
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={errors} />
        <DeleteRecord
          isOpen={openModal}
          title="Delete alarm indicator"
          body="Are you sure you want to delete this alarm indicator?"
          onCancel={() => props.onCancel()}
          onConfirm={() => props.onDeleteAlarmIndicator()}
        />
        <ReactSelect
          containerStyle={{ width: '30%' }}
          isClearable={false}
          label="Department"
          options={departments}
          value={props.deptId}
          onChange={({ value }) => props.onChangeDept(value)}
          valueKey="id"
          labelKey="name"
        />
        <NavButton
          id="new-alarm-indicator-btn"
          to={`/configure/alarm-indicators/new-alarm-indicator/${props.deptId}`}
        >
          <i className="md-icon">add</i>
          {t('New Alarm Indicator')}
        </NavButton>
        <Datagrid
          datagridProps={{
            keyField: 'id',
            data: alarmIndicators,
            loading: isFetching,
            ...datagridProps,
          }}
          ctxMenuOptions={props.ctxMenuOptions}
          exportProps={{
            fileName: 'AlarmIndicators',
          }}
          noPagination
        />
      </div>
    </Backend>
  );
};

export default withTranslation('app')(AlarmIndicatorsPage);
